var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationIcon = function SvgNotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.833,
    d: "M12.586 19.25a1.834 1.834 0 0 1-2.502.67 1.83 1.83 0 0 1-.67-.67M16.5 7.333c0-1.457-.578-2.86-1.613-3.886A5.47 5.47 0 0 0 11 1.833c-1.457 0-2.86.578-3.887 1.614A5.47 5.47 0 0 0 5.5 7.333c0 6.417-2.75 8.25-2.75 8.25h16.5s-2.75-1.833-2.75-8.25"
  })));
};
export { SvgNotificationIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/NotificationIcon.22b909f9.svg";